module.exports = [
    {
        id: 'reasons',
        question: 'Jakie są przyczyny?',
        answer: `
        Jak dotąd nie jest poznana przyczyna tej choroby: w ścianie tętnic nie jest widoczna
        zaawansowana miażdżyca, brak jest też danych o ewidentnym urazie. Do odwarstwienia ściany
        naczynia dochodzi „samoistnie”. Zdarzenie często poprzedzone jest silnym stresem lub wysiłkiem
        fizycznym .
        Choroba dotyczy głównie kobiet w młodym wieku (najczęściej 30-50lat) ale opisywano przypadki
        młodych mężczyzn, jak i kobiet w wieku okołomenopauzalnym. Bardzo rzadko choroba występuje pod
        koniec ciąży lub w pierwszych tygodniach po porodzie.
        Dotychczas nie udokumentowano dziedzicznego podłoża choroby.
        `
    },
    {
        id: 'why',
        question: 'Skąd wiemy, że przyczyną zawału jest właśnie SCAD?',
        image: require('../assets/scad_foto.png'),
        answer: `
        Aby rozpoznać SCAD należy wykonać koronarografię, czyli badanie pozwalające ocenić stan tętnic
        wieńcowych. Przez nadgarstek lub pachwinę kardiolog wprowadza cienką rurkę do serca i podając
        tzw. ”kontrast” może sprawdzić drożność tętnic. Niestety SCAD jest chorobą młodą, może mieć
        różny „wygląd” w koronarografii, dlatego też lekarz wykonujący koronarografię może nie rozpoznać
        spontanicznego rozwarstwienia (zdjęcie). Stąd prawdopodobnie część kobiet, które miały zawał
        serca nie wie, że przyczyną ich zawału był SCAD. 
        `
    },
    {
        id: 'treatment',
        question: 'Jak się leczy SCAD?',
        answer: `
        Podstawą leczenia zawału serca spowodowanego miażdżycą jest przywrócenie przepływu krwi przez
        tętnicę wieńcową. W przypadku spontanicznego rozwarstwienia sposób postępowania jest nieco inny.
        Jeśli tylko tętnica wieńcowa nie jest całkowicie zablokowana, powinna być stosowana strategia
        zachowawcza, czyli farmakologiczne (tabletkowe) wspomaganie mięśnia sercowego, obserwacja i
        oczekiwanie na „wygojenie się” ściany tętnicy.
        Jeśli doszło do całkowitego zablokowania tętnicy, bądź duża część serca objęta jest
        niedokrwieniem preferowana jest angioplastyka wieńcowa (tzw. „balonikowanie”) i założenie stentu
        do tętnicy wieńcowej tj. malutkiego rusztowania które będzie utrzymywało drożność naczynia.
        W bardzo rzadkich przypadkach konieczne jest operacyjne wszczepienie pomostów do tętnic
        wieńcowych tzw. bajpasów. Jest to operacja kardiochirurgiczna polegająca na wytworzeniu pomostów
        omijających zmienione chorobowo odcinki tętnicy.
        `
    },
    {
        id: 'return',
        question: 'Czy SCAD może się powtórzyć?',
        answer: `
        Większość pacjentów po przebyciu choroby wraca do pełnej aktywności: jest aktywna zawodowo, nie
        obserwuje poważnych, fizycznych, ograniczeń w codziennym życiu. Czasami (zdecydowanie rzadziej)
        zawał serca jest jednak tak duży, że prowadzi do upośledzenia normalnego funkcjonowania. Bardzo
        rzadko choroba kończy się śmiercią.
        Chorzy, którzy przebyli epizod SCAD powinni pozostawać pod opieką kardiologa.
        Choroba może niestety nawracać, to znaczy może dojść do wystąpienia rozwarstwienia innej tętnicy
        wieńcowej. Uważa się że prawdopodobieństwo ponownego wystąpienia SCADu wynosi około 5-10% .
        Czynnikiem zwiększającym ryzyko ponownego SCAD jest choroba zwana dysplazją włóknisto-mięśniową
        – jest ona opisana poniżej . Może dojść również do rozwarstwienia tętnic szyjnej lub kręgowej,
        co może być przyczyną udaru mózgu.
        `
    },
    {
        id: 'pregnancy',
        question: 'Czy SCAD ma związek z ciążą? Czy mogę mieć dzieci?',
        answer: `
        Niezmiernie rzadko zdarza się, że kobieta oczekująca na dziecko, doznaje zawału serca: często w
        mechanizmie rozwarstwienia tętnic wieńcowych. Ciąża uważana jest za czynnik ryzyka dla
        wystąpienia SCAD. Uważa się, że kobieta która miała zawał serca spowodowany SCAD nie powinna
        planować ciąży. Jeśli mimo wszystko ją planuje, powinna pozostawać pod opieką doświadczonego
        kardiologa i ginekologa.
        `
    },
    {
        id: 'what-can-i-do',
        question: 'Co mogę dla siebie zrobić?',
        answer: `
        Osoba, który przebyła zawał serca powinna pozostawać pod opieką kardiologa.
        Pacjentki u których rozpoznano SCAD, powinny zostać poddane wnikliwej diagnostyce, gdyż mogą
        współistnieć u nich inne choroby naczyń tętniczych. Jedną z takich chorób jest dysplazja
        włóknisto-mięśniowa. Jest to choroba powodująca zwężenia różnych tętnic, np. tętnic nerkowych
        lub szyjnych, może być przyczyną występowania nadciśnienia tętniczego. U chorych po przebytym
        spontanicznym rozwarstwieniu stwierdzano w wykonanych badaniach tomografii komputerowej obecność
        tętniaków w obrębie m.in. tętnic mózgowych, szyjnych lub nerkowych. Dlatego ważne jest
        przeprowadzenie u osób po przebytym SCAD badań wykluczających te choroby. Takie badania mogą
        zostać przeprowadzone w Instytucie Kardiologii w Warszawie, który posiada największe doświadczenie w diagnostyce i leczeniu Pacjentów z dysplazją włóknisto-mięśniową i po przebytym rozwarstwieniu. Jeżeli rozpoznano u Pani SCAD, lub
        przebyła Pani zawał serca i podejrzewa, że mógł być to SCAD – zapraszamy do kontaktu drogą
        mailową: scad@ikard.pl.
        `
    },
]